import React from 'react';
import {connect} from 'react-redux';
import './styles.scss';

export const SearchCustomer = ({data}) => {
  return (
    <div className='customer-info-container'>
      <table>
        <tr>
          <td className='customer-label'>NOMBRE:</td>
          <td>{data?.customerName}</td>
        </tr>
        <tr>
          <td className='customer-label'>MODELO:</td>
          <td>{data?.modelDescription}</td>
        </tr>
        <tr>
          <td className='customer-label'>UBICACION:</td>
          <td>{data?.location}</td>
        </tr>
        <tr>
          <td className='customer-label'>FECHA DE ARRIBO:</td>
          <td>{(data?.arrivaldate || '').substring(0, 10)}</td>
        </tr>
        <tr>
          <td className='customer-label'>FECHA DE ENTREGA:</td>
          <td>{(data?.prioritizationDate || '').substring(0, 10)}</td>
        </tr>
        <tr>
          <td className='customer-label'>CHASIS:</td>
          <td>{data?.chassis}</td>
        </tr>
      </table>
    </div>
  );
};

export default connect(null, {})(SearchCustomer);
